(function () {
  const MAX_PER_SAMPLE = 5;
  const SAMPLE_PRODUCT_TYPE = 'Echantillons';

  async function getCart() {
    const res = await fetch('/cart.js', {
      credentials: 'same-origin'
    });
    return await res.json();
  }

  function getSampleQtyByVariant(cart, variantId) {
    if (!cart || !cart.items) return 0;

    return cart.items
      .filter(
        item =>
          item.product_type === SAMPLE_PRODUCT_TYPE &&
          item.variant_id === variantId
      )
      .reduce((total, item) => total + item.quantity, 0);
  }

  function showError(message) {
    let notice = document.querySelector('#sample-warning');

    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'sample-warning';

      const cartFooter = document.querySelector('.cart-footer');
      if (cartFooter) {
        cartFooter.prepend(notice);
      } else {
        document.body.prepend(notice);
      }
    }

    notice.textContent = message;
  }

  async function canAddSampleVariant(variantId, qtyToAdd = 1) {
    const cart = await getCart();
    const currentQty = getSampleQtyByVariant(cart, variantId);
    return currentQty + qtyToAdd <= MAX_PER_SAMPLE;
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target;
    if (!form.matches('form[action^="/cart/add"]')) return;

    const productTypeInput = form.querySelector('[name="product_type"]');
    const isSample =
      productTypeInput &&
      productTypeInput.value === SAMPLE_PRODUCT_TYPE;

    if (!isSample) return;

    e.preventDefault();

    const qtyInput = form.querySelector('[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    const variantInput = form.querySelector('[name="id"]');
    const variantId = variantInput ? parseInt(variantInput.value, 10) : null;

    if (!variantId) {
      console.warn('Sample variant ID not found');
      return;
    }

    if (!(await canAddSampleVariant(variantId, qty))) {
      showError(
        `You can only order up to ${MAX_PER_SAMPLE} units of the same sample.`
      );
      return;
    }

    form.submit();
  });

  async function validateCartUI() {
    const cart = await getCart();
    let hasInvalidSample = false;

    cart.items.forEach(item => {
      if (
        item.product_type === SAMPLE_PRODUCT_TYPE &&
        item.quantity > MAX_PER_SAMPLE
      ) {
        hasInvalidSample = true;
      }
    });

    const checkoutButtons = document.querySelectorAll(
      '[name="checkout"], button[href="/checkout"], a[href="/checkout"]'
    );

    checkoutButtons.forEach(btn => {
      if (hasInvalidSample) {
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('disabled');
        showError(
          `Chaque échantillon est limité à ${MAX_PER_SAMPLE} unités par commande.`
        );
      } else {
        btn.removeAttribute('disabled');
        btn.classList.remove('disabled');
        const notice = document.querySelector('#sample-warning');
        if (notice) notice.remove();
      }
    });
  }

  document.addEventListener('click', async function (e) {
    const target = e.target.closest(
      '[name="checkout"], button[href="/checkout"], a[href="/checkout"]'
    );
    if (!target) return;

    const cart = await getCart();
    const invalidSample = cart.items.some(
      item =>
        item.product_type === SAMPLE_PRODUCT_TYPE &&
        item.quantity > MAX_PER_SAMPLE
    );

    if (invalidSample) {
      e.preventDefault();
      showError(
        `Please reduce sample quantities. Maximum is ${MAX_PER_SAMPLE} per sample.`
      );
    }
  });


  document.addEventListener('cart:updated', validateCartUI);
  document.addEventListener('DOMContentLoaded', validateCartUI);

})();



/* RPPS + SIREN conditional fields */
document.addEventListener('DOMContentLoaded', function () {
  const select = document.querySelector('#create_customer select');
  if (!select) return;

  const conditionalFields = [
    {
      block: document.querySelector('.rpps'),
      category: 'Professionnel(le) de santé',
      digits: 11,
      title: 'Le numéro RPPS doit contenir exactement 11 chiffres.',
    },
    {
      block: document.querySelector('.siren'),
      category: 'Professionnel(le) de la petite enfance',
      digits: 9,
      title: 'Le numéro SIREN doit contenir exactement 9 chiffres.',
    },
  ];

  function toggleFields() {
    // Liquid's split(',') leaves leading spaces on values, so trim before comparing
    const selected = select.value.trim();

    conditionalFields.forEach(function (field) {
      if (!field.block) return;
      const input = field.block.querySelector('input');
      const isActive = selected === field.category;

      if (isActive) {
        field.block.classList.remove('hidden');

        if (input) {
          input.required = true;
          input.disabled = false;

          // 🔒 Validation rules
          input.setAttribute('inputmode', 'numeric');
          input.setAttribute('pattern', '\\d{' + field.digits + '}');
          input.setAttribute('maxlength', field.digits);
          input.setAttribute('title', field.title);
        }
      } else {
        field.block.classList.add('hidden');

        if (input) {
          input.required = false;
          input.disabled = true;
          input.value = '';
          input.removeAttribute('pattern');
        }
      }
    });
  }

  // Prevent non-numeric input (UX polish, not security)
  conditionalFields.forEach(function (field) {
    if (!field.block) return;
    const input = field.block.querySelector('input');
    if (!input) return;

    input.addEventListener('input', function () {
      this.value = this.value.replace(/\D/g, '').slice(0, field.digits);
    });
  });

  // Init + listen
  toggleFields();
  select.addEventListener('change', toggleFields);
});